/* FG Google reviews band: arrows, dots and keyboard for the swipeable review row. */
if (!customElements.get('fg-reviews')) {
  customElements.define('fg-reviews', class FgReviews extends HTMLElement {
    connectedCallback() {
      this.rail = this.querySelector('.fg-rv__rail');
      if (!this.rail) return;
      this.items = Array.from(this.rail.children);
      this.dots = Array.from(this.querySelectorAll('.fg-rv__dots i'));
      [this.prev, this.next] = this.querySelectorAll('.fg-rv__arrows button');

      this.prev?.addEventListener('click', () => this.go(-1));
      this.next?.addEventListener('click', () => this.go(1));
      this.rail.addEventListener('scroll', () => requestAnimationFrame(() => this.update()), { passive: true });
      this.rail.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight') { e.preventDefault(); this.go(1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); this.go(-1); }
      });
      new ResizeObserver(() => this.update()).observe(this.rail);
      this.update();
    }

    index() {
      const left = this.rail.scrollLeft;
      let best = 0;
      let distance = Infinity;
      this.items.forEach((item, i) => {
        const d = Math.abs(item.offsetLeft - this.rail.offsetLeft - left);
        if (d < distance) { distance = d; best = i; }
      });
      return best;
    }

    go(dir) {
      const i = Math.max(0, Math.min(this.items.length - 1, this.index() + dir));
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.rail.scrollTo({ left: this.items[i].offsetLeft - this.rail.offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
    }

    update() {
      const i = this.index();
      this.dots.forEach((dot, k) => dot.classList.toggle('is-active', k === i));
      if (this.prev) this.prev.disabled = this.rail.scrollLeft < 4;
      if (this.next) this.next.disabled = this.rail.scrollLeft + this.rail.clientWidth > this.rail.scrollWidth - 4;
    }
  });
}
